import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { HttpHelpService } from "../../service/http-help.service";
import { InvoiceV2Service } from "../../../services/invoice-v2.service";
import {
  getProcedureLabel,
  normalizeProcedureInvoiceRow,
} from "../../invoices-v2/invoice-v2-procedure.util";

@Component({
  selector: "app-view-company",
  templateUrl: "./view-company.component.html",
  styleUrls: ["./view-company.component.scss"]
})

export class ViewCompanyComponent implements OnInit {
  
  curentLang:string="";
  layoutVersion:any;
  userRegistId:any = JSON.parse(localStorage.getItem('user_id'));
  merchantId = JSON.parse(localStorage.getItem('merchant_id'));
  user_type = JSON.parse(localStorage.getItem('user_type'));

  companyInfoData:any=[];
  id:number;
  companyNameAr:string='';
  companyNameEn:string='';
  companyNamehE:string='';
  logoUrl:string='';
  TaxRegister:string='';
  CommercialRegister:string='';
  startInvoiceNumber :string='';
  VatListId :number;
  vatInfoData:any
  VatNameAR:string ='';
  VatNameEN:string='';
  VatNameHE:string='';
  VatPercentage:string='';
  CompanyAddressSTR :string='';
  CompanyAddressSTRAr: string = '';
  CompanyAddressSTREn: string = '';
  CompanyBuildingNumber :string='';
  CompanyAddressCity :string='';
  CompanyAddressCityAr: string = '';
  CompanyAddressCityEn: string = '';
  CompanyAddressZipCode :string='';
  companyPhone: any 

  pendingProcedureInvoices: Record<string, unknown>[] = [];
  loadingPendingProcedures = false;
  procedureModalInvoice: Record<string, unknown> | null = null;
  procedureModalInvoiceId: number | null = null;
  private activeProcedureModal: NgbModalRef | null = null;

  @ViewChild('procedureModal') procedureModalTpl!: TemplateRef<unknown>;

  newOrders = {
    colorClass: "primary",
    icon: "new-order",
    colorClass2: "warning",
    icon2: "customers",
    colorClass3: "success",
    icon4: "invoice",
    colorClass4: "secondary",
    icon3: "profit"
  };
  constructor
  (  
     private spinner: NgxSpinnerService ,
    public translate:TranslateService ,
    private service:HttpHelpService  ,
    private invoiceV2Service: InvoiceV2Service,
    private router: Router,
    private modalService: NgbModal,
    activatedRoute:ActivatedRoute,
    ) 
  { 
    this.curentLang = localStorage.getItem('curentLang') || 'ar';
    this.id = activatedRoute.snapshot.params['id'];
    this.user_type = JSON.parse(localStorage.getItem('user_type'));
    this.merchantId = JSON.parse(localStorage.getItem('merchant_id'));
  };

  getCompanyInfoById() {
    this.spinner.show();
    this.service.getCompanyInfoById(this.id).subscribe({
      next: res => {
        this.companyInfoData = res;       
        this.companyPhone =  this.companyInfoData?.company_phone;
        this.companyNameAr = this.companyInfoData?.company_name_ar;
        this.companyNameEn = this.companyInfoData?.company_name_en;
        this.companyNamehE = this.companyInfoData?.company_name_he;
        this.logoUrl = this.companyInfoData?.logo_url;
        this.TaxRegister = this.companyInfoData?.tax_register;
        this.CommercialRegister = this.companyInfoData?.commercial_register;
        this.startInvoiceNumber = this.companyInfoData?.start_invoice_number;
        this.VatListId = this.companyInfoData?.vat_list_id;
        this.VatNameAR = this.companyInfoData?.vatList?.vat_name_ar;
        this.VatNameEN = this.companyInfoData?.vatList?.vat_name_en;
        this.VatNameHE = this.companyInfoData?.vatList?.vat_name_he;
        this.CompanyAddressSTR = this.companyInfoData?.company_address_str;
        this.CompanyAddressSTRAr = this.companyInfoData?.company_address_str_ar;
        this.CompanyAddressSTREn = this.companyInfoData?.company_address_str_en;
        this.CompanyAddressCity = this.companyInfoData?.company_address_city;
        this.CompanyAddressCityAr = this.companyInfoData?.company_address_city_ar;
        this.CompanyAddressCityEn = this.companyInfoData?.company_address_city_en;
        this.CompanyAddressZipCode = this.companyInfoData?.company_address_zip_code;
        this.CompanyBuildingNumber = this.companyInfoData?.company_Building_number;
        this.spinner.hide();
        this.loadPendingProcedureInvoices();
      },
      error: error => {
        this.spinner.hide();
      }
    });
  };

  loadPendingProcedureInvoices(): void {
    if (!this.id) return;
    this.loadingPendingProcedures = true;
    this.invoiceV2Service
      .getFilteredInvoices({
        companyId: +this.id,
        is_in_procedure_cycle: true,
        limit: 20,
        offset: 0,
      })
      .subscribe({
        next: (res) => {
          this.pendingProcedureInvoices = (res.data || []).map((row: Record<string, unknown>) =>
            normalizeProcedureInvoiceRow(row),
          );
          this.loadingPendingProcedures = false;
        },
        error: () => {
          this.pendingProcedureInvoices = [];
          this.loadingPendingProcedures = false;
        },
      });
  }

  getProcedureLabelForItem(item: Record<string, unknown>): string {
    return getProcedureLabel(item['procedure'] as number | null | undefined, this.curentLang);
  }

  openProcedureModal(item: Record<string, unknown>): void {
    const invoiceId = Number(item['invoice_id']);
    if (!Number.isFinite(invoiceId)) return;
    this.procedureModalInvoice = item;
    this.procedureModalInvoiceId = invoiceId;
    this.activeProcedureModal = this.modalService.open(this.procedureModalTpl, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
    });
  }

  closeProcedureModal(): void {
    this.activeProcedureModal?.close();
    this.activeProcedureModal = null;
    this.procedureModalInvoice = null;
    this.procedureModalInvoiceId = null;
  }

  onProcedureActionCompleted(): void {
    this.closeProcedureModal();
    this.loadPendingProcedureInvoices();
  }

  viewInvoice(invoiceId: number): void {
    this.router.navigate(['/dashboard/invoices-v2/view'], {
      queryParams: { invoiceId },
      state: { invoiceId },
    });
  }

  filter(event:any)
  {
    let x = event.target.value;
   };

  getAllVatList() {
    this.spinner.show();
    this.service.getAllVatList().subscribe({
      next: res => {
        this.vatInfoData = res;
         
        this.spinner.hide();
      },
      error: error => {
        this.spinner.hide();
      }
    });
  };

  ngOnInit() {
    this.getCompanyInfoById();
    this.getAllVatList();
  this.layoutVersion = localStorage.getItem("layout_version");
   if (this.layoutVersion == null || this.layoutVersion == undefined) {
     localStorage.setItem("layout_version", "light-only");
     this.layoutVersion= "light-only"; 
   } else {
     this.layoutVersion = localStorage.getItem("layout_version"); 
     if (this.layoutVersion === "dark-only") {
       document.body.classList.add("dark-only");
     } else {
       document.body.classList.add("light-only");

     }
   }
   this.userRegistId = JSON.parse(localStorage.getItem('user_id'));
   this.merchantId = JSON.parse(localStorage.getItem('merchant_id'));
   this.user_type = JSON.parse(localStorage.getItem('user_type'));
  };
}
